import BaseAPI from "@/api/BaseAPI";

export class RegionAPI extends BaseAPI {
  constructor() {
    super('/region');
  }


  getRegionsWithScanFiles() {
    return this.http.get(`/withScanFiles`)
  }

}

export default new RegionAPI()